<template>
  <div class="fatura-detalhe-page">

    <!-- ── SEÇÃO: Dados da Fatura ── -->
    <div class="form-section" v-if="fatura">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-receipt-text-outline</v-icon>
        </div>
        <div>
          <div class="form-section__title">Dados da Fatura</div>
          <div class="form-section__sub">Informações gerais e valores da fatura</div>
        </div>
        <v-spacer />
        <v-btn color="#0052A0" rounded elevation="0" @click="emitirFatura()" class="px-5 mr-2">
          <v-icon left color="#FFD400" small>mdi-printer</v-icon>
          <span style="color:#FFD400;font-weight:700;font-size:13px">Emitir Fatura</span>
        </v-btn>
        <a v-if="fatura.url_danfnfse" :href="fatura.url_danfnfse" target="_blank" style="text-decoration:none">
          <v-btn outlined rounded elevation="0" color="#0052A0" class="px-5">
            <v-icon left small>mdi-file-document-outline</v-icon>
            <span style="font-size:13px">Nota Fiscal</span>
          </v-btn>
        </a>
      </div>
      <div class="form-section__body">
        <v-row dense>
          <v-col cols="12" md="5">
            <v-text-field outlined dense readonly color="#0052A0"
              label="Empresa" v-model="empresaName" hide-details="auto" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field outlined dense readonly color="#0052A0"
              label="Referência da Fatura" :value="fatura.referencia" hide-details="auto" />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field outlined dense readonly color="#0052A0"
              label="Status" :value="fatura.status ? 'Pago' : 'Em aberto'" hide-details="auto" />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field outlined dense readonly color="#0052A0"
              label="Data Inicial" :value="converterDataTimestamp(fatura.data_inicial)" hide-details="auto" />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field outlined dense readonly color="#0052A0"
              label="Data Final" :value="converterDataTimestamp(fatura.data_final)" hide-details="auto" />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field outlined dense readonly color="#0052A0"
              label="Data de Faturamento" :value="converterDataTimestamp(fatura.data_faturamento)" hide-details="auto" />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field outlined dense readonly color="#0052A0"
              label="Data de Vencimento" :value="converterDataTimestamp(fatura.data_vencimento)" hide-details="auto" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field outlined dense readonly color="#0052A0"
              label="Valor Total da Fatura" :value="converterDinherio(fatura.valor_total)" hide-details />
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- ── SEÇÃO: Serviços ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-format-list-bulleted</v-icon>
        </div>
        <div>
          <div class="form-section__title">Serviços</div>
          <div class="form-section__sub">Itens cobrados nesta fatura</div>
        </div>
        <v-spacer />
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          label="Buscar serviço"
          outlined dense color="#0052A0"
          hide-details
          clearable
          style="max-width:280px"
        />
      </div>
      <div class="form-section__body">
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          class="servicos-table elevation-0"
          no-data-text="Sem dados"
          :footer-props="{
            'items-per-page-text': 'Registros por página: ',
            'page-text': '{0}-{1} de {2}',
            'items-per-page-all-text': 'Listar todos',
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="cell-mono">{{ item.id }}</td>
              <td>{{ item.nome }}</td>
              <td>{{ converterDinherio(item.preco_venda) }}</td>
              <td>{{ converterDataTime(item.created_at) }}</td>
              <td>{{ item.qtd_utilizada }}</td>
              <td>
                <v-chip x-small label
                  :color="item.faturado ? '#dcfce7' : '#fef2f2'"
                  :text-color="item.faturado ? '#166534' : '#991b1b'"
                  style="font-family:'Inter',sans-serif;font-weight:600;"
                >
                  <v-icon x-small left>{{ item.faturado ? 'mdi-check-bold' : 'mdi-close-box' }}</v-icon>
                  {{ item.faturado ? 'Faturado' : 'Pendente' }}
                </v-chip>
              </td>
              <td>{{ converterDinherio(item.preco_venda * item.qtd_utilizada) }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>

    <!-- ── SEÇÃO: Pagamento (apenas se fatura em aberto) ── -->
    <div class="form-section form-section--last"
         v-if="fatura && fatura.status == 0 && pagamentosGerados && pagamentosGerados.length > 0">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-credit-card-outline</v-icon>
        </div>
        <div>
          <div class="form-section__title">Pagar Agora</div>
          <div class="form-section__sub">Realize o pagamento desta fatura</div>
        </div>
      </div>
      <div class="form-section__body">
        <iframe
          :src="pagamentosGerados[0].juno_checkout"
          width="100%"
          height="1000"
          frameborder="0"
          style="border-radius:8px;border:1px solid #f1f5f9;"
        />
      </div>
    </div>

    <img id="itf" style="visibility:collapse;" />
  </div>
</template>

<script>
import helper from "../../mixins/helper";
import modelos from "@/pages/faturamento/fatura_modelo_01.js";

export default {
  mixins: [helper],
  data: () => ({
    faturaId: "",
    formaPagamento: null,
    observacao_pgto: null,
    dataHoje: null,
    formasPagamento: [],
    faturasItems: [],
    dialog: false,
    empresaDados: [],
    pagamentosGerados: [],
    list: [],
    fatura: null,
    fatura_completa: null,
    search: "",
    dtPag: "",
    headers: [
      { text: "ID",           value: "id",                             align: "start", sortable: false },
      { text: "Serviço",      value: "nome",                           align: "start" },
      { text: "Preço Venda",  value: "preco_venda",                    align: "start" },
      { text: "Data/Hora",    value: "created_at",                     align: "start" },
      { text: "Quantidade",   value: "qtd_utilizada",                  align: "start" },
      { text: "Faturado",     value: "faturado",                       align: "start" },
      { text: "Valor Total",  value: "valor_total",                    align: "start" },
    ],
  }),
  computed: {
    empresaName() {
      const u = this.$store.state.auth.user;
      return u && u.domain ? u.domain.name : (this.$route.params.name || '');
    },
  },
  mounted() {
    this.faturaId = this.$route.params.id;
    this.dataHoje = new Date().toISOString().split("T")[0];
    this.dtPag = this.dataHoje;
    this.getFatura();
  },
  methods: {
    getDtPag(data) { this.dtPag = data; },
    copyTestingCode(obj) {
      navigator.clipboard.writeText(obj)
        .then(() => this.notificacao('', 'Código de barras copiado', 'success'))
        .catch(() => alert('Falha ao copiar código de barras'));
    },
    notificacao(title, msg, icon) {
      this.$swal({
        toast: true, position: "center",
        showConfirmButton: false, timer: 3000,
        icon, title, text: msg,
      });
    },
    emitirFatura() {
      modelos.modelo_1(this.fatura_completa);
    },
    async getFatura() {
      try {
        const { data: result } = await this.$http.get("detalhesFatura/" + this.faturaId);
        this.list                = result.servicos;
        this.fatura              = result.fatura;
        this.empresaDados        = result.empresa;
        this.faturasItems        = result.items;
        this.pagamentosGerados   = result.documentos_cobranca;
        this.formasPagamento     = result.formasPagamento;
        this.fatura_completa     = result;
      } catch (error) {
        //
      }
    },
  },
};
</script>

<style scoped>
.fatura-detalhe-page {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last { border-bottom: none; padding-bottom: 0; margin-bottom: 0; }

.form-section__header {
  display: flex; align-items: flex-start; gap: 12px; padding: 0 0 18px 0; flex-wrap: wrap;
}
.form-section__icon-wrap {
  width: 34px; height: 34px; background: #e8f0fe; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.form-section__title { font-family: 'Inter', sans-serif; font-size: 0.92rem; font-weight: 700; color: #1e293b; }
.form-section__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; margin-top: 1px; }
.form-section__body  { padding: 0; }

.servicos-table >>> th {
  font-family: 'Inter', sans-serif !important; font-size: 0.72rem !important;
  font-weight: 700 !important; color: #64748b !important;
  text-transform: uppercase; letter-spacing: 0.5px;
  background: #f8fafc !important; padding: 10px 12px !important; white-space: nowrap;
}
.servicos-table >>> td {
  font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important;
  color: #1e293b !important; font-weight: 400 !important;
  padding: 10px 12px !important; border-bottom: 1px solid #f1f5f9 !important;
}
.cell-mono { font-size: 0.75rem !important; color: #64748b !important; }

.fatura-detalhe-page >>> .v-input__slot { background-color: #fff !important; box-shadow: none !important; }
.fatura-detalhe-page >>> .v-label { font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important; }

@media (max-width: 768px) { .fatura-detalhe-page { padding: 16px; } }
</style>
